<template>
    <div>
        <AssetDetailWidget
            :show-watch-author="true"
            :show-subscription="true"
            :show-rating="true"
            :show-actions="true"
            :show-author="true"
            :show-dates="true"
            :asset="tmpAsset"
            :loading="loading"
            :allow-report-action="userLoggedIn"
            :slider-with-thumbs="true"
            @edit="editAsset"
            @report="reportAsset"
            @delete="deleteAsset"
            @hide="hideAsset"
        />

        <YesNoDialog ref="yesNoDialog" />
        <InfoDialog ref="infoDialog" />
    </div>
</template>

<script>
import { EDIT_ASSET_PAGE_NAME } from '@/router/pageNameConstants';
import Assets from '@/services/assets';
import CreateOrEditAssetMixin from '../../mixins/CreateOrEditAssetMixin';


import Vue from 'vue';
import { mapGetters } from 'vuex';
import {
    addErrorNotification,
    addSuccesNotification,
} from '@/lib/notifications';
import AssetDetailWidget from './AssetDetailWidget.vue';

import YesNoDialog from '@/components/common/modal/ConfirmationDialog.vue';
import InfoDialog from '@/components/common/modal/InfoDialog.vue';

export default {
    components: {
        AssetDetailWidget,
        YesNoDialog,
        InfoDialog,
    },
    created() {
            this.tmpAsset = {...this.serialiseAsset(this.asset)};
    },
    mixins: [CreateOrEditAssetMixin],
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        asset: {
            type: Object,
            default: function() {
                return {};
            },
        },
    },
    data() {
        return {
            showModal: false,
            modalData: {},
            tmpAsset: {}
        };
    },
    watch: {
        asset(newAsset) {
            if (Object.keys(newAsset).length === 0) {
                return;
            }
            this.tmpAsset = {...this.serialiseAsset(newAsset)};
        }
    },
    computed: {
        ...mapGetters('user', {
            userId: 'getUserId',
        }),
        userLoggedIn() {
            return !!this.userId;
        },
    },
    methods: {
        serialiseAsset(data) {
            const { 
                name,
                tags,
                content_type: contentType,
                monetized_actions: monetizedActions,
                description,
                changelog,
                screenshots,
                protected: _protected,
                hidden,
                thumbnail,
                released_at: releasedAt,
                asset_guid: assetGuid,
                metadata,
                published,
                updated_at: updatedAt,
                subscribers_count: subscribersCount,
                verified_author: verifiedAuthor,
                id,
                user_id: userId,
                videos,
                revision,
            } = data;

            const updatedAsset = {
                name,
                tags,
                hidden,
                published,
                contentType,
                monetizedActions,
                description,
                metadata,
                userId,
                changelog,
                releasedAt,
                assetGuid,
                updatedAt,
                media: [...(videos || []),...(screenshots || [])],
                mediaToDelete: [],
                protected: _protected,
                thumbnail,
                subscribersCount,
                verifiedAuthor,
                revision,
                assetGuid,
                id,
            };

       
            if (!this.tmpAsset.mediaToDelete) {
                updatedAsset.mediaToDelete = [];
            }
            return updatedAsset;

        },
        editAsset(asset) {
            this.$router.replace({
                name: EDIT_ASSET_PAGE_NAME,
                id: asset.id,
                query: { step: 'binaryFileAndThumb' },
                params: { btnDisplay: true },
            });
        },
        belongsToLoggedInUser() {
            return this.asset.user_id === this.userId;
        },
        async reportAsset() {
            let confirmation = await this.$refs.yesNoDialog.init(
                'Report this asset?',
                'Thanks for helping ' +
                'us to find assets with harmful and abusive content.<br> More information ' +
                'about allowed content you can find <a href="https://ylands.com/eula" ' + // eslint-disable-next-line vue/script-indent
                    'target="_blank"  rel="noopener,noreferrer">here</a>',
                'Report'
            );
            if (confirmation) {
                try {
                    await Assets.report(this.asset.id, this.asset.revision);
                    addSuccesNotification('Report sent successfully');
                } catch (e) {
                    if (e.apiCode === 'ylandsApiService.assetExists') {
                        addErrorNotification(
                            'You already reported this creation.'
                        );
                        return;
                    }
                    addErrorNotification('Unable to report this creation');
                    return;
                }
            }
        },

        async deleteAsset() {
            let agree = await this.$refs.yesNoDialog.init('Delete this asset?');
            if (!agree) {
                return;
            }
            try {
                await Assets.delete(this.asset.id);
                addSuccesNotification('Creation deleted');
                return this.$router.push({ name: 'dashboard' });
            } catch (e) {
                console.error('Unable to delete asset', e);
                addErrorNotification('Unable to delete creation');
            }
        },

        async hideAsset(hide) {
            let agree = await this.$refs.yesNoDialog.init(
                hide ? 'Hide this asset?' : 'Show this asset?'
            );
            if (!agree) {
                return;
            }
            try {
                await Assets.patch(
                    this.asset.id,
                    {
                        hidden: hide,
                    },
                    {}
                );
                Vue.set(this.asset, 'hidden', hide);
                Vue.set(this.tmpAsset, 'hidden', hide);
                addSuccesNotification(hide ? 'Asset hidden' : 'Asset shown');
            } catch (e) {
                console.error(e);
                addErrorNotification('Unable change watch status');
            }
        },
    },
};
</script>

<style lang="scss"></style>
